const constants = require('@/util/constants')
require('./config')

/**
 * 获取浏览访客
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function users (successcb, failedcb) {
  axios.get('/api/browse/users', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取某个访客浏览记录
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function queryBrowses (page, size, uid, successcb, failedcb) {
  axios.get('/api/browse/query', {
    params: {
      'page': page,
      'size': size,
      'uid': uid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 分页获取访客浏览记录
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function queryBrowseAdmin(page, size, successcb, failedcb) {
  axios.get('/api/browse/query/admin', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 根据访客在线状态 分页获取访客浏览记录
 * 
 * @param {*} status 
 * @param {*} page 
 * @param {*} size 
 * @param {*} successcb 
 * @param {*} failedcb 
 */
export function queryBrowseAdmin2(status, page, size, successcb, failedcb) {
  axios.get('/api/v2/browse/query/admin', {
    params: {
      'status': status,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

//
export function queryOnlineUsers(page, size, successcb, failedcb) {
  axios.get('/api/user/all/online/sub', {
    params: {
      'page': page,
      'size': size,
      // 'subDomain': subDomain,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// export function getBrowses (page, size, successcb, failedcb) {
//   axios.get('/api/browse/request', {
//     params: {
//       'page': page,
//       'size': size,
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 邀请正在浏览访客
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function inviteBrowse (bid, successcb, failedcb) {
  axios.post('/api/browse/invite', {
    bid: bid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
